<div class="animated fadeIn rounded">
  <div class="card">
    <div class="card-header">
      <i class="fa fa-fingerprint"></i> Biometría
      <div class="card-header-actions btn-group" dropdown placement="bottom left">
        <button class="btn btn-sm btn-success" *ngIf="isAuthActive && showTokenButton" type="button"
          appPrivilege="activateAuthCredit" (appPrivilegeClick)="deactivateAuthCredit()"><i
            class="fa fa-solid fa-check"></i>&nbsp;Autorización de Crédito
          Activado</button>
        <button class="btn btn-sm btn-outline-danger" *ngIf="!isAuthActive && showTokenButton" type="button"
          appPrivilege="activateAuthCredit" (appPrivilegeClick)="activateAuthCredit()"><i
            class="fa fa-solid fa-circle-exclamation"></i>&nbsp;Autorización de Crédito

          Desactivado</button>
      </div>
    </div>
    <div class="card-body">
      <div class="row mb-3">
      </div>
      <div class="mb-3 border">
        <app-customer-information (currentCustomerChange)="handleSelectedCustomerChange($event)" [hideButtons]="true"
          [hideCreditInformation]="true" *ngIf="!this.isForInvoice && !this.isForCashLoan && !this.isForCreditRequest">
        </app-customer-information>
        <div class="row" *ngIf="this.isForInvoice || this.isForCashLoan || this.isForCreditRequest">
          <div class="col-sm-1 d-flex justify-content-center align-items-center p-0">
            <i class="fa fa-user fa-5x" aria-hidden="true"></i>
          </div>
          <div class="col-sm-4">
            <div class="item">
              <div class="item-label">
                Identidad:
              </div>
              <div class="item-info">
                {{customer?.mainPersonalInfo?.fiscalId ? customer?.mainPersonalInfo?.fiscalId :
                ''}}
              </div>
            </div>
            <div class="item">
              <div class="item-label">
                Tipo:
              </div>
              <div class="item-info" *ngIf="customer.code !== ''">
                {{customer?.mainPersonalInfo?.personality === 'PERSON' ? 'NATURAL' : 'JURIDICO' }}
              </div>
            </div>
            <div class="item">
              <div class="item-label">
                Nombre:
              </div>
              <div class="item-info">
                {{customer?.mainPersonalInfo?.fullName}}
              </div>
            </div>
          </div>
        </div>
      </div>


      <tabset>
        <!-- <tab>
          <ng-template tabHeading><i class="fa fa-upload"></i> Subir fotografía</ng-template>
          <div class="row">
          <div class="col-12">
            <div class="row">
              <div class="col-1">
              <label class="mr-3 col-form-label" [for]="'attachment'">
                <b>Imagen</b>
                <span class="text-danger">*</span>
              </label>
            </div>
              <div class="col-4">
                <input type="file" [id]="'attachment'" (change)="onFileChange($event)">
                <label class="custom-file-label mb-2"
                  [for]="'attachment'">{{ filename ? filename : 'Elija el archivo' }}</label>
            </div>
            <div class="col-2">
              <button id="btnSearchCustomer" class="btn btn-outline-primary" (click)="validatePicture()"><i
                class="fa fa-check"></i>&nbsp;Validar
              Fotografía</button>
            </div>

          </div>
            <div class="row">
              <canvas #uploadCanvas class="border" width="640" height="480"></canvas>
            </div>
          </div>
        </tab> -->
        <tab>
          <ng-template tabHeading><i class="fa fa-fingerprint"></i> Tomar huella digital</ng-template>
          <app-biometry-finger-print #biometryFingerPrint [customerSelected]="customer" [isForInvoice]="isForInvoice"
            [showActionButtonWithApprove]="showActionButtonWithApprove"
            [showActionButtonWithoutApprove]="showActionButtonWithoutApprove"
            [textActionButtonWithApprove]="textActionButtonWithApprove"
            [textActionButtonWithoutApprove]="textActionButtonWithoutApprove"
            [creditRequestNumber]="creditRequestNumber" [biometryCompleted]="biometryCompleted"
            (biometryResultEmitter)="biometryResultEmitter.emit($event)"
            (biometryErrorEmitter)="biometryErrorEmitter.emit($event)"
            (clickActionButtonWithApprove)="clickActionButtonWithApprove.emit()"
            (clickActionButtonWithoutApprove)="clickActionButtonWithoutApprove.emit()"
            (cleanEmitter)="cleanEmitter.emit()"></app-biometry-finger-print>
        </tab>
        <tab>
          <ng-template tabHeading><i class="fa fa-camera"></i> Tomar fotografía</ng-template>
          <div class="row">
            <div class="col-8 col-md-6">
              <div class="btn-group mb-3">
                <button class="btn btn-outline-primary" type="button" [hidden]="toggleVideoFlag"
                  (click)="toggleVideo(true)" title="Activar Cámara" [disabled]="biometryCompleted">
                  <i class="fa fa-play"></i> Activar Cámara
                </button>
                <button class="btn btn-outline-primary" type="button" [hidden]="!toggleVideoFlag"
                  (click)="toggleVideo(false)" title="Desactivar Cámara" [disabled]="biometryCompleted">
                  <i class="fa fa-pause"></i> Desactivar Cámara
                </button>
                <button class="btn btn-outline-primary" type="button" (click)="capturePhoto()" title="Tomar Foto"
                  [disabled]="biometryCompleted">
                  <i class="fa fa-camera"></i> Tomar Foto
                </button>
                <button class="btn btn-outline-primary" type="button" (click)="deletePicture()" title="Limpiar"
                  [disabled]="biometryCompleted">
                  <i class="fa fa-trash"></i> Limpiar
                </button>
                <button id="btnSearchCustomer" class="btn btn-outline-primary" (click)="validatePicture()"
                  [disabled]="biometryCompleted"><i class="fa fa-check"></i>&nbsp;<span>Validar
                    Fotografía</span></button>
                <button *ngIf="showActionButtonWithApprove" id="btnActionWithApprove" class="btn btn-outline-warning"
                  (click)="clickActionButtonWithApprove.emit()"><i
                    class="fa fa-check"></i>&nbsp;<span>{{textActionButtonWithApprove}}</span></button>
                <button *ngIf="showActionButtonWithoutApprove" id="btnActionWithoutApprove"
                  class="btn btn-outline-success" (click)="clickActionButtonWithoutApprove.emit()"><i
                    class="fa fa-check"></i>&nbsp;<span>{{textActionButtonWithoutApprove}}</span></button>
              </div>
            </div>
            <div class="col-8 col-md-4">
              <!-- <h5>Resultado</h5>
              <h5 [hidden]="!result.valid || !result.errorMessage" class="bg-success"><i
                  class="fa fa-check "></i>Proceda a ingresar facturación ó solicitud de crédito</h5>
              <h5 [hidden]="result.valid || !result.errorMessage" class="bg-danger">
                Revisión con el área de crédito</h5>
              <h5 [hidden]="result.errorMessage" class="bg-warning">Pendiente</h5> -->

              <h5>Resultado</h5>

              <div *ngIf="(!isForInvoice && !isForCashLoan && !isForCreditRequest)">

                <h5 *ngIf="result.valid && result.errorMessage != ''" class="bg-success"><i
                    class="fa fa-check "></i>Proceda a ingresar facturación ó solicitud de crédito</h5>

                <h5 *ngIf="!result.valid && result.errorMessage != '' && result.errorMessage == 'NO'" class="bg-danger">
                  Revisión con el área de crédito</h5>

                <h5 *ngIf="!result.valid && result.errorMessage != '' && result.errorMessage != 'NO'" class="bg-danger">
                  {{result.errorMessage}} ,continuar proceso establecido según su tienda</h5>

              </div>

              <div *ngIf="isForInvoice || isForCashLoan || isForCreditRequest">
                <h5 *ngIf="result.valid && result.errorMessage != ''" class="bg-success"><i
                    class="fa fa-check "></i>Proceda a ingresar facturación ó solicitud de crédito</h5>

                <h5 *ngIf="!result.valid && result.errorMessage != '' && result.errorMessage == 'NO'" class="bg-danger">
                  Solicite autorización {{errorTextUser}}
                </h5>

                <h5 *ngIf="!result.valid && result.errorMessage != '' && result.errorMessage != 'NO'" class="bg-danger">
                  {{result.errorMessage}}, solicite autorización {{errorTextUser}}</h5>
              </div>




              <h5 [hidden]="result.errorMessage" class="bg-warning">Pendiente</h5>
            </div>

          </div>
          <div class="row">
            <div class="col-12">
              <div class="row">
                <div class="col-12 col-md-12 col-sm-12">
                  <video class="border" #hardwareVideo width="640" height="480" [hidden]="pictureTaken"
                    style="max-width: 640px; max-height: 480px;"></video>
                  <canvas #takenCanvas class="border" width="640" height="480" [hidden]="!pictureTaken"
                    style="max-width: 640px; max-height: 480px;"></canvas>
                </div>
              </div>
            </div>
          </div>
        </tab>
      </tabset>
    </div>
  </div>
</div>

<!-- Nav tabs -->


<!--/.col-->